import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import PageCanvas from '../components/ui/PageCanvas';
import PageHeader from '../components/ui/PageHeader';
import Panel from '../components/ui/Panel';
import ActionButton from '../components/ui/ActionButton';

const DetApp = () => {
  return (
    <PageCanvas>
      <PageHeader
        title="Detapp"
        subtitle="Access the Detapp external application."
      />

      <Panel title="External Application Access">
        <div className="flex items-center justify-between gap-4">
          <p className="text-textSecondary" style={{ fontSize: '0.875rem' }}>
            Access external development tools and resources to enhance your Detapp workflow.
          </p>
          <a href="https://beeonixdetapp.bigtapp.net/" target="_blank" rel="noreferrer">
            <ActionButton variant="primary" endIcon={ArrowTopRightOnSquareIcon}>
              Navigate to External App
            </ActionButton>
          </a>
        </div>
      </Panel>
    </PageCanvas>
  );
};

export default DetApp;
